const SearchIcon = (props) => {
    return (
        <div>
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 6.24225C0 9.68513 2.80098 12.483 6.24079 12.483C7.82555 12.483 9.27518 11.8872 10.3778 10.9106L14.355 14.8878C14.4287 14.9615 14.524 14.9984 14.6222 14.9984C14.7205 14.9984 14.8157 14.9615 14.8894 14.8878C15.0369 14.7404 15.0369 14.5039 14.8894 14.3565L10.9091 10.3792C11.8857 9.27666 12.4816 7.83009 12.4816 6.24225C12.4816 2.79938 9.68059 0.00146484 6.24079 0.00146484C2.80098 0.00146484 0 2.79938 0 6.24225ZM11.7291 6.24225C11.7291 9.26744 9.26597 11.7306 6.24079 11.7306C3.2156 11.7306 0.752457 9.26744 0.752457 6.24225C0.752457 3.21707 3.2156 0.753922 6.24079 0.753922C9.26597 0.753922 11.7291 3.214 11.7291 6.24225Z" fill="#696969"/>
            </svg>
        </div>
    );
}

export default SearchIcon;